import styled from 'styled-components';

const OutlinedContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 4px;
  margin-bottom: 16px;
`;

export default OutlinedContainer;
